import { makeAutoObservable, runInAction } from 'mobx';

import ApiService from 'src/services/ApiService';
import { STORE_NAME } from 'src/utils/constants';
import { handleStateError } from 'src/errors';
import { HealthTracker } from 'src/models/healthTrackers/HealthTracker';
import { RootStore } from './RootStore';

export default class HealthTrackersStore {
  private static storeName = STORE_NAME.HEALTH_TRACKERS_STORE;
  private rootStore: RootStore;
  private apiService: ApiService;

  public healthTrackers?: HealthTracker[];

  constructor(rootStore: RootStore, apiService?: ApiService) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
    this.apiService = apiService || new ApiService(this.rootStore.authStore.getWhsAccessToken);
  }

  getHealthTrackers = async (): Promise<HealthTracker[] | undefined> => {
    try {
      const healthTrackers = await this.apiService.getHealthTrackers();

      if (healthTrackers) {
        runInAction(() => {
          this.healthTrackers = healthTrackers;
        });
      }

      return this.healthTrackers;
    }
    catch (error) {
      handleStateError(error, HealthTrackersStore.storeName);
    }
  };
}
